import React, { HTMLAttributes } from "react";

export interface Heading2Props extends HTMLAttributes<HTMLHeadingElement> {
  emoji?: string;
}

const Heading4: React.FC<Heading2Props> = ({
  children,
  emoji = "",
  className = "justify-center",
  ...args
}) => {
  return (
    <div 
    style={{marginBottom:"2rem", marginTop:'2rem'}}
      className={`nc-Section-Heading relative flex flex-col sm:flex-row sm:items-end justify-between ${className}`}
    >
     <div className="desktop-container">
  <h2
    className="font-mobile font-semibold whitespace-nowrap"
    {...args}
  >
    {children || "Section Heading"}
  </h2>

  <div className="grow h-[2px] bg-red-500" />
</div>
    </div>
  );
};

export default Heading4;
